module.exports = __webpack_public_path__ + "static/fonts/PorscheNext-Italic.c89dd117.otf";